export enum PUBLICATION_TYPE {
  SALE = '1',
  BANNER = '2',
  TIMER = '3',
  IMAGES = '4',
}
